import React from 'react';
import LongText from '../../../Elements/LongText';
import { TpPlatformInvoiceCostTypeLabels } from '../../../Enums/TpPlatformInvoiceCostTypesEnum';

export default class TpPlatformInvoiceLineItem {
  constructor(item) {
    if (item === undefined) {
      this.TpPlatformInvoiceItemId = '';
      this.TpPlatformInvoiceId = '';
      this.CostType = '';
      this.ThirdPartyBillingCode = '';
      this.ThirdPartyClientId = '';
      this.TpClientLinkId = '';
      this.ThirdPartyCompany = '';
      this.CaspianClientName = '';
      this.OfficeName = '';
      this.ThirdPartyItemCount = '';
      this.ThirdPartyQuantity = '';
      this.ThirdPartyRate = '';
      this.ThirdPartyAmount = '';
      this.CurrencyCode = '';
      this.CreatedOnUtc = null;
      return;
    }
    this.TpPlatformInvoiceItemId = item.tpPlatformInvoiceItemId;
    this.TpPlatformInvoiceId = item.tpPlatformInvoiceId;
    this.CostType = item.costType ? item.costType : '';
    this.ThirdPartyBillingCode = item.thirdPartyBillingCode ? item.thirdPartyBillingCode : '';
    this.ThirdPartyClientId = item.thirdPartyClientId ?? '';
    this.TpClientLinkId = item.tpClientLinkId;
    this.ThirdPartyCompany = item.thirdPartyCompany ? item.thirdPartyCompany : '';
    this.CaspianClientName = item.caspianClientName ? item.caspianClientName : '';
    this.OfficeName = item.officeName ? item.officeName : '';
    this.ThirdPartyItemCount = item.thirdPartyItemCount ?? '';
    this.ThirdPartyQuantity = item.thirdPartyQuantity ?? '';
    this.ThirdPartyRate = item.thirdPartyRate ?? '';
    this.ThirdPartyAmount = item.thirdPartyAmount ?? '';
    this.CurrencyCode = item.currencyCode ? item.currencyCode : '';
    this.CreatedOnUtc = item.createdOnUtc;
  }

  static displayedInList = 'ThirdPartyCompany';

  static NameOfTheIdField() {
    return 'TpPlatformInvoiceItemId';
  }

  static nameOfTheItemDetailList() {
    return 'Platform Invoice Item';
  }

  // Rate and Amount carry the row's own import-stamped currency; the sub-tab item classes
  // (Assignment / AdditionalFee / Development) inherit these and their string-named money columns.
  static MoneyFields = ['ThirdPartyRate', 'ThirdPartyAmount'];
  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc'];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static getCostTypeCellContent(item) {
    return TpPlatformInvoiceCostTypeLabels[item.CostType] || item.CostType;
  }

  static getCaspianClientCellContent(item) {
    // Invoice-level rows (texts, virtual numbers) have no client at all — show nothing.
    if (item.ThirdPartyClientId === '' || item.ThirdPartyClientId === null) {
      return '';
    }
    if (item.CaspianClientName) {
      return item.CaspianClientName;
    }
    // A link without a Caspian client is a normal state — the mirror stays faithful to the
    // invoice and shows the platform's own client id/company until a client is mapped.
    return <span className='warningText'>Unresolved</span>;
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Billing Code',
        orderById: 'ThirdPartyBillingCode',
        data: 'ThirdPartyBillingCode',
        minWidth: 50,
      },
      {
        label: 'Cost Type',
        orderById: 'CostType',
        data: (item) => TpPlatformInvoiceLineItem.getCostTypeCellContent(item),
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'TP Client ID',
        orderById: 'ThirdPartyClientId',
        data: 'ThirdPartyClientId',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Company',
        orderById: 'ThirdPartyCompany',
        data: (d) => (
          <LongText
            text={d.ThirdPartyCompany}
            maxLength={30}
          />
        ),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Caspian Client',
        orderById: '',
        data: (item) => TpPlatformInvoiceLineItem.getCaspianClientCellContent(item),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Office',
        orderById: '',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Count',
        orderById: '',
        data: 'ThirdPartyItemCount',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Quantity',
        orderById: '',
        data: 'ThirdPartyQuantity',
        className: 'text-right',
        minWidth: 30,
      },
      {
        label: 'Rate',
        orderById: '',
        data: 'ThirdPartyRate',
        className: 'text-right',
        minWidth: 30,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'ThirdPartyAmount',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
